import React from 'react';
import { LoadingCommonProps } from 'src/formcontrols/Loading';
import VirtusSpinner from 'src/formcontrols/Loading/virtus-spinner.gif'
import { LoadingDataGrid } from '@virtus/components/Loading';

export interface LoadingSpinnerProps extends Partial<LoadingCommonProps> {
  alt?: string;
  size?: number;
  src?: string;
  style?: React.StyleHTMLAttributes<HTMLDivElement>;
  type?: 'light' | 'dark';
}
export const LoadingSpinner: React.FunctionComponent<LoadingSpinnerProps> = ({
  alt = 'loading spinner...',
  src,
  type = 'dark',
  size = 70,
  style,
}) => (type === 'dark'?
  <img
    alt={alt}
    src={VirtusSpinner}
    width={size}
    height={size}
    style={style}
  />:<LoadingDataGrid show={true} />
);

export default LoadingSpinner;
